export function concatenateArrays(
	...args: (string[] | undefined | null)[]
): string[] {
	return args
		.flat()
		.filter(
			(item): item is string => typeof item === "string" && item.length > 0,
		);
}
